import CardModule from '../../shared/card-module';
import TableBasic from '../../../atoms/table-basic';
import format from '../../../../utils/format';
import useInvestmentByType from '../../../../stores/profile/modules/use-investment-by-type';
import { className } from '../../../../utils/GlobalCssProxy';

const InvestmentByType = () => {
  const { asOfDate, investmentByType, ticker } = useInvestmentByType();

  return (
    <CardModule
      data-analytics-componenttype="twothirds-width-component"
      data-analytics-id="TTW_InvestmentByType"
      data-analytics-section="component"
    >
      <CardModule.Header>
        Investment By Type
        <CardModule.AsOfDate>{format.date(asOfDate)}</CardModule.AsOfDate>
      </CardModule.Header>
      <CardModule.Body>
        <TableBasic flush>
          <caption {...className('sr-only')}>{`Investment by type for ${ticker}`}</caption>
          <thead>
            <tr>
              <th>Investment</th>
              <th {...className('text-right')}>% of Net Assets</th>
            </tr>
          </thead>
          <tbody>
            {investmentByType.map((item, index) => {
              return (
                <tr
                  data-key={`${item.sector || ''}-${index}`}
                  key={`${item.sector || ''}-${index}`}
                >
                  <td>{format.text(item.sector)}</td>
                  <td {...className('text-right')}>{format.percent(item.valuePercent)}</td>
                </tr>
              );
            })}
          </tbody>
        </TableBasic>
      </CardModule.Body>
    </CardModule>
  );
};

export default InvestmentByType;
